export default __webpack_public_path__ + "static/what-to-do-in-japan-timing-it-right-blossoms-d845901f832854c1fff3bdc3e84a7d2c.jpg";